export function TheLinescoreIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="10" y="6" width="28" height="36" rx="3" />
      <line x1="10" y1="14" x2="38" y2="14" />
      <line x1="10" y1="22" x2="38" y2="22" />
      <line x1="10" y1="30" x2="38" y2="30" />
      <line x1="18" y1="14" x2="18" y2="42" />
      <line x1="24" y1="6" x2="24" y2="42" />
      <line x1="30" y1="14" x2="30" y2="42" />
      <path d="M14 8h8" strokeWidth="1.5" />
      <path d="M26 8h8" strokeWidth="1.5" />
    </svg>
  );
}
